import React from "react";
import { System } from "../../commons/Constants";
import { QueryParam } from "../../commons/Constants";
import { useLanderConfig } from "../../commons/ConfigContext";

export const CopyrightCashParking = () => {
  const { landerConfig, queryConfig } = useLanderConfig();
  const showDomainName =
    queryConfig[QueryParam.SHOW_DOMAIN] ||
    landerConfig.system !== System.PARKWEB;
  if (showDomainName) {
    // default is false for this template
    const domainName =
      landerConfig.lander.domainDisplayName || landerConfig.domain.rootDomain;
    return (
      <span id="copyright">
        Copyright &copy; {domainName}. &nbsp;All rights reserved.
      </span>
    );
  }
  return (
    <span id="copyright">Copyright &copy; &nbsp;All rights reserved.</span>
  );
};
